module.exports = __webpack_public_path__ + "media/Air_Plane_Ding-SoundBible.com-496729130.b506a66a.mp3";